// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name= BrowseExtInfoModal] .container {\r\n\t\tjustify-content: space-between;\r\n\t}", ""]);
// Exports
module.exports = exports;
